import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {CLSelectorOption} from 'common/src/components/Selectors/CLSelector/CLSelector.types';
import {BreadcrumbName} from '../../breadcrumbs/breadcrumbs.enums';
import {TimezoneObject} from '../../timezones/timezones.types';
import {Dashboard, DashboardPageState, DashboardWidget} from '../dashboards.types';

const initialState: DashboardPageState = {
  activeWidgetId: null,
  dashboards: [],
  widgets: [],
  dashboardId: 0,
  isLoading: false,
  metricsAndDimensionsOptions: {metrics: [], dimensions: []},
  filters: [],
  startDate: '',
  endDate: '',
  timezone: '',
  timezoneOptions: [],
};

const dashboardPageSlice = createSlice({
  name: BreadcrumbName.Dashboard,
  initialState,
  reducers: {
    resetState: (state) => ({...initialState, activeWidgetId: state.activeWidgetId}),
    updateActiveWidgetId: (state, action: PayloadAction<number>) => {
      state.activeWidgetId = action.payload;
    },
    updateDashboardPage: (state, action: PayloadAction<Partial<DashboardPageState>>) => {
      return {...state, ...action.payload};
    },
    updateDashboards: (state, action: PayloadAction<Dashboard[]>) => {
      state.dashboards = action.payload;
    },
    updateWidgets: (state, action: PayloadAction<DashboardWidget[]>) => {
      state.widgets = action.payload;
    },
    updateDashboardId: (state, action: PayloadAction<number>) => {
      state.dashboardId = action.payload;
    },
    updateIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    updateDateRange: (state, action: PayloadAction<{startDate: string; endDate: string}>) => {
      state.startDate = action.payload.startDate;
      state.endDate = action.payload.endDate;
    },
    updateTimezone: (state, action: PayloadAction<string>) => {
      state.timezone = action.payload;
    },
    updateTimezoneOptions: (
      state,
      action: PayloadAction<(CLSelectorOption & TimezoneObject)[]>,
    ) => {
      state.timezoneOptions = action.payload;
    },
  },
});

export const {
  resetState,
  updateActiveWidgetId,
  updateDashboards,
  updateWidgets,
  updateDashboardPage,
  updateDashboardId,
  updateIsLoading,
  updateDateRange,
  updateTimezone,
  updateTimezoneOptions,
} = dashboardPageSlice.actions;

export default dashboardPageSlice.reducer;
